import type { Product } from 'src/components/restructure/product/types/product'
import { Image } from 'src/components/ui/Image'
import { useProductLink } from 'src/sdk/product/useProductLinkV2'

import ProductInfo from './ProductInfo'
import { WrapperElement } from './LinkWrapper'

type ProductCardV2Props = {
  product: Product
  currentProduct?: boolean
  onSelect: React.Dispatch<React.SetStateAction<string | null>>
  selectedSku?: string | null
}

const ProductCardV2 = ({
  product,
  currentProduct = false,
  onSelect,
  selectedSku,
}: ProductCardV2Props) => {
  const { items, productName, linkText } = product

  const firstAvailable = items.find((item) => item.isAvailable)

  const productLink = useProductLink({
    product,
    currentSku: firstAvailable,
    index: 0,
    slug: linkText,
    shelfRef: `Vitrine: Compre Junto${
      product?.sport ? ` - ${product?.sport}` : ''
    }`,
    ...(product?.slotId && { engine: 'dy' }),
  })

  if (!firstAvailable) {
    return null
  }

  const img = firstAvailable?.images[0]

  const {
    sellerOffer: { cashPrice, listPrice },
  } = firstAvailable.sellerDefault

  return (
    <div className="flex md:flex-col gap-3 w-full">
      <WrapperElement
        productLink={productLink}
        enableCardLink={!currentProduct}
      >
        <div className="w-fit md:w-full relative">
          <div className="mix-blend-multiply bg-restructure-background-secondary">
            <Image
              src={img.imageUrl}
              alt={img?.imageText ?? productName}
              className="w-40 md:w-[364px] min-w-[160px] max-w-full mix-blend-multiply bg-restructure-background-secondary"
              width={364}
            />
          </div>

          {currentProduct && (
            <span className="hidden md:block absolute text-sm font-semibold text-[#101010] top-0 right-0 p-2 bg-white/70 text-center">
              Vendo agora
            </span>
          )}
        </div>
      </WrapperElement>
      <ProductInfo
        productName={productName}
        listPrice={listPrice}
        sellPrice={cashPrice}
        onSelect={onSelect}
        filterList={['Cor']}
        product={product}
        selectedSku={selectedSku}
        currentProduct={currentProduct}
        productLink={productLink}
      />
    </div>
  )
}

export default ProductCardV2
